module.exports = __webpack_public_path__ + "static/battle02-f2ef1973bda658472cc00a6033ec73ca.png";